import { createGlobalStyle } from 'styled-components';

export const MachinePositionHistoryMapGlobalStyles = createGlobalStyle`
  .machine-position-history-map-popover-overlay {
    z-index: 999;
    min-width: 200px;
    max-width: 260px;

    .ant-popover-arrow {
      display: none;
    }
  }

  .ant-popover-inner {
    border-radius: 0 !important;
    padding: 12px;
  }
`;
